import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../header/header";
import Footer from "../footer/footer";
import Footer1 from "../footer/footer1";
import axios from "axios";
import { baseApiUrl } from "../../../services/api";


function DetailProfile() {
  const [utilisateur, setUtilisateur] = useState(null);
  const { profileId } = useParams();

  useEffect(() => {
    if (profileId) {
      baseApiUrl
        .get(`/utilisateur/${profileId}`)
        .then((response) => {
            setUtilisateur(response.data);
          console.log("user récupéré :", response.data);
        })
        .catch((error) => {
          console.error("Erreur lors de la récupération du user :", error);
        });
    } else {
      console.error("L'ID du projet est introuvable !");
    }
  }, [profileId]);

  if (!utilisateur) return <p>Chargement des informations...</p>;
  return (
    <detail>
      <Header />
      <div
        className="inner-hero bg-cover"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/bg/inner-hero-bg.jpg)`,
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="main-heading">
               
                <h1>Profile details</h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="blog-details1-all sp">
        <div className="container">
         

          <br /><br />

          <div className="row">
          <div class="col-lg-4">
						<div class="blog1-sidebar-area mt-40 ml-30 sm:ml-0 md:ml-0 md:mt-30 sm:mt-30">
							{/* <div class="sidebar-details-widget_1 _search-area1">
								<h3>Search</h3>
								<form action="#">
									<input type="text" placeholder="Search..." />
								</form>
							</div> */}
							<div class="sidebar-details-widget_1 _author-intro mt-40">
								<div class="sidebar-author-thumb text-center">
                                <img
                    //   className="w-full"
                    className="rounded-circle"
                               width="100"
                               height="100"
                      src={ baseApiUrl.defaults.baseURL +`/image/${utilisateur.photo}`}
                      alt="Project"
                    />									<h4>{utilisateur.nom}-{utilisateur.prenom}</h4>
                        <p className="mt-2">
                               
                                
                             </p>									<div class="heading1">
										<p>Whether you’re a tech enthusiast or a business leader, these emerging trends are reshaping the future and offering endless opportunities for growth and creativity.</p>
									</div>
									{/* <div class="footer-social1">
										<ul>
											<li>
												<a href="#"><i class="fa-brands fa-facebook-f"></i></a>
											</li>
											<li>
												<a href="#"><i class="fa-brands fa-linkedin-in"></i></a>
											</li>
											<li>
												<a href="#"><i class="fa-brands fa-instagram"></i></a>
											</li>
											<li>
												<a href="#"><i class="fa-regular fa-basketball"></i></a>
											</li>
											<li>
												<a href="#"><i class="fa-brands fa-behance"></i></a>
											</li>
										</ul>
									</div> */}
								</div>
							</div>
							
						
						
						</div>
					</div>
            <div className="col-lg-8">
              <div className="details content-area mt-40">
               

                        <article>
								<div class="heading1 mt-40">
									<h3>Information sur {utilisateur.nom}</h3>
									<p class="mt-16">Different social media platforms serve different purposes, and each has its own user demographics. Selecting the right platforms for your brand is essential. For instance:</p>
									{/* <p class="mt-16 p-with-sapn"><span>Date de naissance:</span>{utilisateur.datedenaissance} </p> */}
									<p class="mt-10 p-with-sapn"><span>Nom:</span >{utilisateur.nom}</p>
									<p class="mt-10 p-with-sapn"><span>Prenom:</span>{utilisateur.prenom} </p>
								</div>
							</article>
                          

                            <article>
								{/* <div class="heading1 mt-40">
									<h3>Contacts</h3>
									<p class="mt-16">Different social media platforms serve different purposes, and each has its own user demographics. Selecting the right platforms for your brand is essential. For instance:</p>
									<p class="mt-16 p-with-sapn"><span>Addresse 1:</span>{utilisateur.adresse.adresse1} </p>
									<p class="mt-10 p-with-sapn"><span>Adresse 2:</span>{utilisateur.adresse.adresse1} </p>
									<p class="mt-10 p-with-sapn"><span>Pays:</span>{utilisateur.adresse.pays} </p>
									<p class="mt-10 p-with-sapn"><span>Ville:</span>{utilisateur.adresse.ville} </p>
                                    <p class="mt-10 p-with-sapn"><span>Code postal :</span> </p>
									<p class="mt-10 p-with-sapn"><span>Site web:</span> </p>
									<p class="mt-10 p-with-sapn"><span>Email:</span> {utilisateur.email} </p>
								</div> */}
							</article>

            
              </div>
            </div>


           
         
          </div>
        </div>
      </div>

    

      <Footer1 />

      <Footer />
    </detail>
  );
}

export default DetailProfile;
